import { Button } from "components"
import { Fragment } from "react"
import { APPROVAL, useToggle } from "utils"
import { IoSendSharp } from "react-icons/io5"
import { ApprovalBillServiceSchema } from "../types"
import { ModalApproveBillService } from "./ModalApproveBillService"
import { PERMISION } from "security"

type ApprovalBillServiceActionProps = {
  data: ApprovalBillServiceSchema 
  refetch: () => void
}

export const ApprovalBillServiceAction = ({ data, refetch }: ApprovalBillServiceActionProps) => {
  const { isActive, toggle } = useToggle(false)

  return (
	<Fragment>
	  <Button
		type="button"
		color="ghost"
		permission={PERMISION.PURCHASES.TRANSACTION.APPROVAL_PAYMENT_BILL_SERVICE.UPDATE}
		onClick={toggle}
		disabled={Boolean(data?.approval_status === APPROVAL.REJECTED || data?.approval_status === APPROVAL.APPROVED)}
	  >
		<IoSendSharp />
	  </Button>

	  {isActive && <ModalApproveBillService toggle={toggle} data={data} refetch={refetch} />}
	</Fragment>
  )
}